import { StyleSheet, Dimensions } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const modalHeight = Dimensions.get('screen').height * 0.65;
export default StyleSheet.create({
  loadingViewContainer: {
    height: modalHeight,
    justifyContent: 'center',
    alignItems: 'center',
  },

  loadingDescription: {
    marginTop: 3,
    fontFamily: Fonts.type.VodafoneLt,
    fontWeight: '400',
    fontSize: 20,
    color: Colors.dark_grey,
  },
  lottieViewStyle: { width: 150, height: 150 },
});
